import { DateTime } from 'luxon';

const isoToDate = (date, currentTimezone) => DateTime.fromISO(date, { zone: currentTimezone }).toFormat('EEEE, MMMM dd, yyyy');

export default isoToDate;
